var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntersectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.049,
    height: 32.015,
    viewBox: "0 0 32.049 32.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-590.056 -288.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2438",
    d: "M432.038,196.815c-.067-.18-.818-2.86-1.67-5.957l-1.548-5.629-5.879-1.631c-3.233-.9-5.86-1.664-5.836-1.7s2.67-.8,5.88-1.7l5.836-1.625,1.615-5.858c.888-3.222,1.653-5.858,1.7-5.858s.81,2.636,1.7,5.858l1.615,5.858,5.828,1.623c3.206.893,5.828,1.661,5.828,1.707s-2.623.814-5.829,1.707l-5.829,1.623-1.644,5.956C432.449,196.094,432.138,197.084,432.038,196.815Z",
    transform: "translate(174 123)",
    fill: "#d821ff",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersectionIcon);
export default __webpack_public_path__ + "static/media/intersection-icon.e1e58146a937393b77dbe0b12add1d88.svg";
export { ForwardRef as ReactComponent };